import { useState, useEffect } from 'react';
import { getJiraWorklogs, getJiraAllTasks } from './getJiraIssueApi';

export const useJiraData = (allTasks, startDate, endDate) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [unauthorized, setUnauthorized] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          setUnauthorized(true);
          return;
        }

        let fetchedData;
        if (allTasks) {
          fetchedData = await getJiraAllTasks(
            startDate.toISOString().split("T")[0],
            endDate.toISOString().split("T")[0]
          );
        } else {
          fetchedData = await getJiraWorklogs(
            startDate.toISOString().split("T")[0],
            endDate.toISOString().split("T")[0]
          );
        }

        setData(fetchedData);
      } catch (err) {
        console.error(err);
        setError(err.message || 'Wystąpił nieznany błąd');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [allTasks, startDate, endDate]);

  return { loading, error, data, unauthorized };
};
